module.exports = __webpack_public_path__ + "img/guizhouHints_25.ef71d327.jpg";